module.exports = __webpack_public_path__ + "static/media/automated-icon.7fce66c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/automated-icon.png
// module id = 90
// module chunks = 0